exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.panel-add__header {\n  color: #fff;\n  text-decoration: none;\n}\n.panel-add__label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.panel-add__card {\n  min-height: 20rem;\n}", "", {"version":3,"sources":["/home/appuser/frontend/src/components/recommendations/AddAnother.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,sBAAsB;CACvB;AACD;EACE,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;CACzB;AACD;EACE,kBAAkB;CACnB","file":"AddAnother.vue","sourcesContent":["\n.panel-add__header {\n  color: #fff;\n  text-decoration: none;\n}\n.panel-add__label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.panel-add__card {\n  min-height: 20rem;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/stylus-loader?{"paths":["node_modules/vuetify/src/stylus/"],"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./frontend/src/components/recommendations/AddAnother.vue
// module id = T254
// module chunks = 0